import FullPageLayout from 'Components/layout/FullPageLayout'
import React from 'react'

const FAQs = () => {
  return (
    <FullPageLayout headerText={'FAQs'}>
      
    </FullPageLayout>
  )
}

export default FAQs